const COOKIE_PREFIX = 'cookie_consent'
const LOCALSTORAGE_PREFIX = 'cookie_consent_log'
const COOKIE_VERSION = 'v1'
const EXPIRY_DAYS = 365
const EXPIRY_MS = EXPIRY_DAYS * 24 * 60 * 60 * 1000

// Consent is namespaced per client (tenant) so that a decision made for one
// client is never applied to another client served on the same host. When no
// clientId is available (e.g. preview or root page) we fall back to the global
// key to preserve previous behaviour.
function cookieName(clientId) {
  return clientId ? `${COOKIE_PREFIX}_${clientId}` : COOKIE_PREFIX
}

function logKey(clientId) {
  return clientId ? `${LOCALSTORAGE_PREFIX}_${clientId}` : LOCALSTORAGE_PREFIX
}

function parseCookie(clientId) {
  try {
    const match = document.cookie.match(new RegExp('(?:^|; )' + cookieName(clientId) + '=([^;]*)'))
    if (!match) return null

    const raw = decodeURIComponent(match[1])
    const parts = raw.split('|')
    if (parts.length < 3 || parts[0] !== COOKIE_VERSION) return null

    const timestamp = parts[1]
    if (Date.now() - new Date(timestamp).getTime() > EXPIRY_MS) return null

    const cats = {}
    parts[2].split(',').forEach((pair) => {
      const [k, v] = pair.split(':')
      cats[k] = v === '1'
    })

    return { version: parts[0], timestamp, categories: cats }
  } catch (e) {
    return null
  }
}

function writeCookie(categories, clientId, policies = {}) {
  const timestamp = new Date().toISOString()
  const cats = `n:1,a:${categories.analytics ? 1 : 0},m:${categories.marketing ? 1 : 0}`
  const value = encodeURIComponent(`${COOKIE_VERSION}|${timestamp}|${cats}`)
  const expires = new Date(Date.now() + EXPIRY_MS).toUTCString()
  const secureFlag = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${cookieName(
    clientId
  )}=${value}; expires=${expires}; path=/; SameSite=Lax${secureFlag}`

  try {
    localStorage.setItem(
      logKey(clientId),
      JSON.stringify({
        version: '1.0',
        clientId: clientId || null,
        timestamp,
        categories: { necessary: true, ...categories },
        consentId: Math.random().toString(36).substring(2),
        method: 'banner',
        pageUrl: window.location.href,
        // Capture the policy URLs the user was shown at consent time so the
        // audit log proves which (tenant-specific) policies they agreed to.
        policies: {
          privacyPolicyUrl: policies.privacyPolicyUrl || null,
          cookiesPolicyUrl: policies.cookiesPolicyUrl || null,
        },
      })
    )
  } catch (e) {
    // localStorage unavailable — cookie alone is sufficient
  }

  window.dispatchEvent(new Event('consentUpdated'))
}

const ConsentManager = {
  getConsent(clientId) {
    return parseCookie(clientId)
  },

  setConsent(categories, clientId, policies) {
    writeCookie(categories, clientId, policies)
  },

  acceptAll(clientId, policies) {
    writeCookie({ analytics: true, marketing: true }, clientId, policies)
  },

  rejectAll(clientId, policies) {
    writeCookie({ analytics: false, marketing: false }, clientId, policies)
  },

  hasConsentDecision(clientId) {
    return parseCookie(clientId) !== null
  },

  hasAnalyticsConsent(clientId) {
    const consent = parseCookie(clientId)
    return consent !== null && consent.categories['a'] === true
  },

  hasMarketingConsent(clientId) {
    const consent = parseCookie(clientId)
    return consent !== null && consent.categories['m'] === true
  },

  revokeConsent(clientId) {
    document.cookie = `${cookieName(clientId)}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    try {
      localStorage.removeItem(logKey(clientId))
    } catch (e) {
      // ignore
    }
    window.location.reload()
  },
}

export default ConsentManager
